import Vue from 'vue'
import moment from 'moment'
import { formatMoney } from "@/global"

Vue.filter('date', function(value, format){
    return moment(value).format(format)
})


Vue.filter('formatMoney', function(value, format){
    return formatMoney(value, format.decimais, format.sigla, format.milhar, format.decimal)
})